import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      if (mode === 'login') await login(form.email, form.password);
      else await register(form);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || t('common.error'));
    } finally { setLoading(false); }
  };

  return (
    <div style={S.page}>
      <div style={S.hexBg} />
      <div style={S.card}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{ fontSize: 40, display: 'block', marginBottom: 8 }}>🍯</span>
          <h1 style={{ fontSize: 28, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, color: '#2C1A0E' }}>Colmena</h1>
          <p style={{ fontSize: 13, color: '#8B6355', marginTop: 4 }}>{t('login.tagline')}</p>
        </div>

        <div style={S.tabs}>
          {['login','register'].map(m => (
            <button key={m} onClick={() => { setMode(m); setError(''); }}
              style={{ ...S.tab, ...(mode === m ? S.tabActive : {}) }}>
              {m === 'login' ? t('login.enterTab') : t('login.registerTab')}
            </button>
          ))}
        </div>

        <form onSubmit={submit}>
          {mode === 'register' && (
            <div className="form-group">
              <label className="form-label">{t('login.nameLabel')}</label>
              <input name="name" value={form.name} onChange={handle} className="form-input" placeholder={t('login.namePlaceholder')} required />
            </div>
          )}
          <div className="form-group">
            <label className="form-label">{t('login.emailLabel')}</label>
            <input name="email" type="email" value={form.email} onChange={handle} className="form-input" placeholder={t('login.emailPlaceholder')} required />
          </div>
          <div className="form-group">
            <label className="form-label">{t('login.passwordLabel')}</label>
            <input name="password" type="password" value={form.password} onChange={handle} className="form-input" placeholder="••••••••" required />
          </div>
          {error && <div style={S.error}>{error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 12 }} disabled={loading}>
            {loading ? '...' : mode === 'login' ? t('login.enterBtn') : t('login.registerBtn')}
          </button>
          {mode === 'login' && (
            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <Link to="/forgot-password" style={{ color: '#8B6355', fontSize: 13, textDecoration: 'none' }}>
                {t('login.forgotLink')}
              </Link>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

const S = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'linear-gradient(135deg, #FDF0DC 0%, #F5C47A 50%, #E8922A 100%)', position: 'relative' },
  hexBg: { position: 'absolute', inset: 0, opacity: 0.06, backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='52' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0 L60 17.3 L60 34.6 L30 52 L0 34.6 L0 17.3Z' fill='%232C1A0E'/%3E%3C/svg%3E\")", backgroundSize: '60px 52px' },
  card: { background: 'rgba(255,252,248,0.96)', backdropFilter: 'blur(12px)', borderRadius: 24, padding: 40, width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(44,26,14,0.2)', position: 'relative', zIndex: 1 },
  tabs: { display: 'flex', background: '#F8F4EF', borderRadius: 10, padding: 4, marginBottom: 24, gap: 0 },
  tab: { flex: 1, padding: 8, borderRadius: 8, border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: '#8B6355', transition: 'all 0.15s' },
  tabActive: { background: 'white', color: '#2C1A0E', fontWeight: 500, boxShadow: '0 1px 4px rgba(44,26,14,0.12)' },
  error: { background: '#FDECEA', color: '#C0392B', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
};
